import { updateState } from './product-selection-state'
import { updateCustomerPartNumber } from '../putup/customer-part-number'
import { toggleUomPrice } from '../pricing/price-display'
import { updateElement } from './updaters/element-updater'
import { updateSpecialOrderColors } from './updaters/special-order-updater'
import { updateColorButtons } from './updaters/color-button-updater'
import { updateStyleButtons } from './updaters/style-button-updater'
import { updateSizeButtons } from './updaters/size-button-updater'

export function handleProductSelectionResponse(data) {
  const boxNumber = data.render_sleeving ? 1 : 2
  
  updateDomElements(boxNumber, data.html)
  updateSelectionState(data.selection_state)
  updateSelectedClasses(data.selection_state)
  updateUrl(data.product_share_link)
  handlePricing(boxNumber, data)
  updateCustomerPartNumber()
  reattachHandlers()
}

function updateDomElements(boxNumber, html) {
  updateElement(`#image-holder-${boxNumber}`, html.image)
  updateElement(`#inventory-bar-${boxNumber}`, html.inventory_bar)
  updateElement(`#name-holder-${boxNumber}`, html.product_name)
  updateElement('#order-history', html.order_history)
  updateElement('#color-picker-container', html.color_picker)
  updateElement('#style-picker-container', html.style_picker)
  updateSpecialOrderColors(html.special_order_colors)
  updatePutups(boxNumber, html.put_ups)
}

function updatePutups(boxNumber, html) {
  if (!html) return
  
  const element = document.getElementById(`put-up-holder-${boxNumber}`)
  if (element) {
    element.innerHTML = html
  }
}

function updateSelectionState(selectionState) {
  const stateElement = document.getElementById('product-selection-state')
  if (stateElement) {
    updateState(stateElement, selectionState)
  }
}

function updateSelectedClasses(selectionState) {
  updateColorButtons(selectionState.color)
  updateStyleButtons(selectionState.style)
  updateSizeButtons(selectionState.size)
}

function updateUrl(url) {
  history.replaceState('', 'Techflex', url)
}

function handlePricing(boxNumber, data) {
  if (data.is_special_order) {
    toggleUomPrice(0)
  } else if (data.has_item_putups) {
    const selectedButton = document.querySelector('.uom-picker-button.selected')
    const priceBreaks = selectedButton?.dataset.priceBreaks
    if (priceBreaks) {
      const firstPrice = JSON.parse(priceBreaks)[0]?.price
      if (firstPrice) {
        toggleUomPrice(firstPrice)
      }
    }
  }
}

function reattachHandlers() {
  const event = new CustomEvent('product-selection:updated')
  document.dispatchEvent(event)
}
